import { endPoints, requestType } from "../lib/variable";
import Api from "./index";

const getAllSubscriptions = (payload) => {
  return Api(endPoints.getAllSubscriptions, payload, requestType.GET);
};

export { getAllSubscriptions };
